export enum ClientStatusEnum {
  Active = 'Ativo',
  Inactive = 'Inativo',
  Converted = 'Convertido',
}
